module.exports = __webpack_public_path__ + "img/portrait_2.18b0892c.png";